import React, { Fragment, useEffect, useState, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import GoogleAnalytics from '../services/GoogleAnalytics';
import Loader from 'react-loader-spinner';

//Components
import Navbar from '../components/Navbar';
import FormSearch from '../components/FormSearch';
import PymeContactBox from '../components/PymeContactBox';
import PymeInfoBox from '../components/PymeInfoBox';
import PymeBusinessHours from '../components/PymeBusinessHours';
import PymeCategoriesSection from '../components/PymeCategoriesSection';
import PymeAlternativesSection from '../components/PymeAlternativesSection';
import ClientCard from '../components/ClientCard';
import Footer from '../components/Footer';
import ServicesSearch from '../services/ServicesSearch';
import ControlBtns from '../components/ControlBtns';

import history from '../history';
import '../App.scss';

//Redux
import {getParams} from '../store/params/reducer';
import {connect} from 'react-redux';

const Details = (props) => {
  const isCancelled = useRef(false);
  const [pyme, setPyme] = useState({});
  const [loader, setLoader] = useState(true);
  const [loc, setLoc] = useState(props.params.location);

  const [show, setShow] = useState(() => {
    return window.innerWidth<768 ? false : true;
  });

  const [showFilters, setShowFilters] = useState(() => {
    return window.innerWidth<768 ? false : true;
  });

  const [search, setSearch] = useState({
    query: props.params.search,
    location: props.params.location,
    [props.params.locationType]: props.params.locationValue,
    defaultLocation: JSON.stringify(props.params.location)
  });

  const gaCategory = process.env.REACT_APP_GA_CATEGORY;

  useEffect(() => {
    const validateData = () => {
      window.scrollTo(0, 0);
      let params = {
        _id: props.match.params.rut,
      };

      ServicesSearch.getDataPyme(params)
        .then((response) => {
          !response.data['hits'].length && history.push('/');
          if (!isCancelled.current) {
            setLoader(false);
            setPyme(response.data['hits'][0]._source);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
          history.push('/');
        });
    };
    validateData();
    return () => {
      isCancelled.current = true;
    };
  }, [props.match.params.rut]);

  return (
    <Fragment>
      <Navbar />
      {loader ? (
        <div className="spinner-d">
          <Loader
            type="Oval"
            color="#00BFFF"
            height={50}
            width={50}
            className="spinner-1"
          />
        </div>
      ) : (
        <>
          <div className="row">
            {
              window.innerWidth>768 ?
                <div className="col-md-2 d-flex align-items-center">
                  <button
                    className="btn btn-default default-bordered"
                    style={{ marginTop: '60px', boxShadow: '0 0 black' }}
                    onClick={() => history.goBack()}
                  >
                    <FontAwesomeIcon icon={faArrowLeft} className="m-r-10" />{' '}
                    Regresar
                  </button>
                </div>
              :
                null
            }
            <div className="col-md-10 px-0">
              <ControlBtns
                show={show}
                setShow={setShow}
                showFilters={showFilters}
                setShowFilters={setShowFilters}
                view={'details'}
                history={history}
              />

              <FormSearch
                classForm={'col-lg-12 np-sides'}
                rowClass={'px-0'}
                search={search}
                setSearch={setSearch}
                loc={loc}
                setLoc={setLoc}
                responsiveMenu={true}
                show={show}
                setShow={setShow}
                />
            </div>
          </div>

          <div className="row d-none d-sm-block">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/" style={{color:'#000000'}}>Compra Pyme</a></li>
                <li className="breadcrumb-item active" aria-current="page">
                {typeof pyme.categoryArr !== 'undefined' &&
                pyme.categoryArr !== null &&
                pyme.categoryArr.length > 0
                  ? ' ' +pyme.categoryArr[0]
                  : ''}
                </li>
              </ol>
            </nav>
          </div>

          <div className="row py-0 my-0">
            <div className="col-md-7 px-0 d-none d-sm-block">
              <h1 className="title">{pyme.namePyme}</h1>
            </div>
            <PymeContactBox pyme={pyme} />
            <ClientCard pyme={pyme}  />
          </div>
          <div className="row py-0 my-0" id="contactanos">
            <div className="col-md-8 py-0 my-0 px-0">
              <hr className="border-top border-dark d-sm-none"/>
              <div className="row px-0 py-0 d-sm-none">
                <div className="col-lg-12 px-0">
                  <p style={{ fontSize:'18px' }}>
                    <strong>Encuéntranos en:</strong>
                  </p>
                  { typeof pyme.virtualStore !== 'undefined' && pyme.virtualStore !== null && pyme.virtualStore !== '' && pyme.virtualStore === 'No' ? (
                    <p style={{ fontSize:'18px' }} >
                      <span style={{textTransform: 'capitalize'}}> { pyme.streetPyme + ", " + pyme.streetPymeNumber + ", " + pyme.comune + ". " + pyme.regionName} </span>
                    </p>
                  ) : (
                    typeof pyme.virtualStore !== 'undefined' && pyme.virtualStore !== null && pyme.virtualStore !== '' && pyme.virtualStore === 'Yes' ? (
                      <p style={{ fontSize:'18px' }} >
                        <span>En nuestra tienda virtual. {pyme.comune + ". " + pyme.regionName}</span>
                      </p>
                    ) : (
                      <p style={{ fontSize:'18px' }} >
                        <span style={{textTransform: 'capitalize'}}> { pyme.streetPyme && pyme.streetPymeNumber ? pyme.streetPyme + ", " + pyme.streetPymeNumber + ", " + pyme.comune + ". " + pyme.regionName : pyme.comune + ". " + pyme.regionName} </span>
                      </p>
                    )
                  ) }
                  <p style={{ fontSize:'18px' }} >
                    <strong>Correo electrónico: </strong>
                    <a style={{ color: '#000000' }}
                       href={'mailto:' + pyme.mailPyme}
                       onClick={() =>
                         GoogleAnalytics.addEvent(
                           gaCategory,
                           'Click Correo Electrónico',
                           pyme.namePyme,
                           ''
                         )
                       }
                       target="_blank">
                      {pyme.mailPyme}
                    </a>
                  </p>
                  <p style={{ fontSize:'18px' }} >
                    <strong>Teléfono: </strong>
                    <a style={{ color: '#000000' }}
                      href={'tel:+56' + pyme.phonePyme}
                      onClick={() =>
                        GoogleAnalytics.addEvent(
                          gaCategory,
                          'Click Teléfono',
                          pyme.namePyme,
                          ''
                        )
                      }
                      target="_blank">
                      {pyme.phonePyme}
                    </a>
                  </p>
                </div>
              </div>
              <hr className="mb-0 border-top border-dark" />
              <PymeInfoBox pyme={pyme} />
              <hr className="mb-0 border-top border-dark" />
              <div className="row py-0 my-4 px-0">
                <div className="col-lg-12 px-0">
                  <PymeBusinessHours pyme={pyme} />
                </div>
              </div>
              <hr className="mb-0 border-top border-dark" />
              <div className="row py-0 my-4 px-0">
                <div className="col-lg-12 px-0">
                  <PymeCategoriesSection categories={pyme.categoryTree} />
                </div>
              </div>


              <div className="form-group col-sm col-md-2 btn-m-t-31 d-sm-none">
                <input
                  type="button"
                  className={
                    'btn btn-block btn-search btn-lg px-5'
                  }
                  onClick={() => document.getElementById('contactanos').scrollIntoView()}
                  value="Hablemos"
                />
              </div>


              <hr className="mb-0 border-top border-dark" />
            </div>
          </div>
          <div className="row py-0 my-4">
            <div className="col p-0">
              <PymeAlternativesSection pyme={pyme} />
            </div>
          </div>
        </>
      )}
      <Footer />
    </Fragment>
  );
}

const mapStateToProps = state => {
  return {
    params: getParams(state)
  };
};

export default connect(mapStateToProps, {})(Details);
